import type { ApiModuleEndpoints } from '../types'

export const channelApiEndpoints = {
  list: { method: 'GET', path: '/channels', requiresAuth: true },
  options: { method: 'GET', path: '/channels/options', requiresAuth: true },
  // Tạo kênh bán tạm ẩn (disabled).
  // create: { method: 'POST', path: '/channels', requiresAuth: true },
  detail: { method: 'GET', path: '/channels/:id', requiresAuth: true },
  update: { method: 'PUT', path: '/channels/:id', requiresAuth: true },
  delete: { method: 'DELETE', path: '/channels/:id', requiresAuth: true },
  products: { method: 'GET', path: '/channels/:id/products', requiresAuth: true },
  syncProducts: { method: 'PUT', path: '/channels/:id/products', requiresAuth: true },
  publicProducts: { method: 'GET', path: '/product-by-online-channel', requiresAuth: false },
  publicMemberLookup: { method: 'POST', path: '/product-by-online-channel/member-lookup', requiresAuth: false },
} as const satisfies ApiModuleEndpoints
